var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intersect',{on:{"enter":_vm.onEnter}},[_c('div',{staticClass:"intersect-block",class:{ active: _vm.active },style:(("transition-delay: " + _vm.delay + "s"))},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }